// ─── Configuración de API ────────────────────────────────────────────────────
// Se usan URLs RELATIVAS (/api/v1) para que el frontend siempre llame al mismo
// servidor desde donde está corriendo — sin importar si es:
//   - http://localhost:8080  (tunnel SSH para pruebas)
//   - https://216.250.112.120  (IP directa)
//   - https://analisisoperativo.com  (dominio en producción)
// Esto evita errores de CORS y hace el switcheo de dominio totalmente transparente.

import { isNativePlatform } from './utils/envUtils';

const config = {
  production: {
    API_URL: '/api/v1'           // Relativo → mismo origen siempre
  },
  staging: {
    API_URL: '/staging/api/v1'   // Relativo → va por nginx al backend staging
  },
  development: {
    API_URL: process.env.REACT_APP_API_URL || '/api/v1'
  }
};

const isStagingPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/staging');
const env = process.env.REACT_APP_ENV || (isStagingPath ? 'staging' : 'production');

// Helper para garantizar que en Capacitor / App Móvil las URLs relativas se conviertan a absolutas
export const getResolvedApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.pathname.startsWith('/staging') || window.location.hostname.includes('staging')) {
      return '/staging/api/v1';
    }
  }
  let rawUrl = process.env.REACT_APP_API_URL || (config[env] ? config[env].API_URL : '/api/v1');
  if (rawUrl.startsWith('/') && isNativePlatform() && typeof window !== 'undefined' && window.location.port !== '3000') {
    return `https://analisisoperativo.com${rawUrl}`;
  }
  return rawUrl;
};

// Exportamos como getter o constante dinámica
export let API_BASE_URL = getResolvedApiBaseUrl();

// Definimos un getter en Object para garantizar que siempre resuelva en runtime
try {
  Object.defineProperty(exports, 'API_BASE_URL', {
    get: getResolvedApiBaseUrl,
    configurable: true
  });
} catch (e) {}


export const getHealthUrl = () => {
  const baseUrl = API_BASE_URL.replace(/\/v1\/?$/, '');
  if (baseUrl.startsWith('/')) {
    return `${window.location.origin}${baseUrl}/health`;
  }
  return `${baseUrl}/health`;
};

// ─── Helper Universal para URLs de Fotos y Multimedia ───────────────────────
// Resuelve la URL correcta para imágenes tanto en APK (donde origin es https://localhost)
// como en navegador web (HTTPS en producción sin Mixed Content).
export const getMediaBaseUrl = () => {
  // En APK nativa (Capacitor en celular):
  // window.location.origin es https://localhost, las imágenes están en el servidor real.
  if (
    isNativePlatform() || 
    (typeof window !== 'undefined' && window.location.hostname === 'localhost' && window.location.port !== '3000' && window.location.port !== '8002')
  ) {
    return 'https://analisisoperativo.com';
  }

  // En navegador web (producción o staging bajo el mismo dominio):
  if (typeof window !== 'undefined' && window.location.origin && !window.location.origin.includes('localhost')) {
    return window.location.origin;
  }

  return 'https://analisisoperativo.com';
};

export const getFullPhotoUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = getMediaBaseUrl();
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (clean.startsWith('/static/')) {
    return `${base}${clean}`;
  }
  return `${base}/static/uploads/${path.replace(/^\/+/, '')}`;
};

